import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { CentroService } from '@core/services/centro.service';
import { OperacionesDestacadasComponent } from '@features/home/components/operaciones-destacadas/operaciones-destacadas.component';
import { UltimasPrevisionesComponent } from '@features/home/components/ultimas-previsiones/ultimas-previsiones.component';
import { UltimoStockComponent } from '@features/home/components/ultimo-stock/ultimo-stock.component';
import { ICentro } from '@models/ICentros';
import { TranslateModule } from '@ngx-translate/core';
import { KeysEstaticas } from '@shared/constantes/KeysStaticas';
import { UltimasPrevisionesInternasComponent } from "@features/home/components/ultimas-previsiones-internas/ultimas-previsiones-internas.component";
import { IUsuarioSQL } from '@models/IUserModel';
import { IGestor } from '@models/IOperador';
import { OperadorService } from '@core/services/operador.service';
import { NGXLogger } from 'ngx-logger';
import { IconComponent } from "@shared/icon/icon.component";
import { AlertasService } from '@core/services/alertas.service';
import { NotificationsComponent } from "@features/home/components/notifications/notifications.component";
import { SessionService } from '@core/services/session.service';
import { UserApiService } from '@core/services/user-api.service';

@Component({
  selector: 'app-home',
  imports: [
    MatExpansionModule,
    OperacionesDestacadasComponent,
    UltimasPrevisionesComponent,
    UltimoStockComponent,
    CommonModule,
    NgOptimizedImage,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    UltimasPrevisionesInternasComponent,
    IconComponent,
    NotificationsComponent
  ],
  providers: [DatePipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  readonly PERFIL_CLIENTE = KeysEstaticas.PERFIL_CLIENTE;
  readonly PERFIL_PROVEEDOR = KeysEstaticas.PERFIL_PROVEEDOR;
  readonly PREVISISION_PEDIDO_INTERNO = KeysEstaticas.PREVISISION_PEDIDO_INTERNO
  readonly panelOpenState = signal(false);
  perfil!: string;
  prevision!: string;
  datosGestor = signal<IGestor | undefined>(undefined);
  username = '';
  ultimoStockDate = '';
  centrosTrabajo: ICentro[] = [];
  centroId = signal<ICentro>({
    id: 0,
    nombre: '',
  });
  // notifications = signal<INotification[]>([]);
  expanded = signal(true);
  constructor(
    public centroService: CentroService,
    public operadorService: OperadorService,
    private logger: NGXLogger,
    private alertaService: AlertasService,
    private sessionService: SessionService,
    private userApiService: UserApiService
  ) { }

  ngOnInit(): void {
    const user = this.sessionService.getUserInfo();
    if (!user) {
      return;
    }

    this.username = user.username;
    this.getCentrosTrabajo();
    // this.getNotificaciones();
    this.getGestorCliente();
    this.perfil = user.perfil;
    this.prevision = user.prevision;
    this.logger.info('HomeComponent ngOnInit');


  }

  getDateUltimoStock(date: string) {
    this.ultimoStockDate = date;
  }

  getCentrosTrabajo() {
    const user = this.sessionService.getUserInfo();

    if (!user) {
      return;
    }

    const getCentros = user.perfil == KeysEstaticas.PERFIL_DISTRIBUIDOR ? this.userApiService.getUserCenters(user.username) : this.centroService.getCentros();
    getCentros.subscribe((r) => {
      this.centrosTrabajo = r;
      const centroId = this.sessionService.getUserInfo()!.idCentroTrabajo;
      this.centroId.set(
        this.centrosTrabajo.find(c => c.id === Number(centroId)) ?? this.centrosTrabajo[0]
      );
    });
  }

  onCentroChange(event: MatSelectChange) {
    if (event.value) {
      const userSql: IUsuarioSQL =
        { usuario: this.username, idCentroTrabajo: event.value.id, idioma: this.sessionService.getUserInfo()!.idioma };
      this.userApiService.editUser(userSql).subscribe({
        next: () => {
          // actualizar la sesión
          // const userSession: IUserSession = this.sessionService.getUserInfo()!;
          // userSession.idCentroTrabajo = event.value.id;
          this.sessionService.editUserSession({ idCentroTrabajo: event.value.id });
          this.centroId.set(event.value);

          this.alertaService.showAlert('success', 'Ok', 'COMPARTIDOS.ALERTA.CENTRO_TRABAJO_ACTUALIZADO');

        },
        error: (err) => {
          this.logger.error('Error al actualizar el centro de trabajo', err);
        }
      });
    }
  }

  // getNotificaciones() {
  //   this.operadorService.getNotificaciones().subscribe({
  //     next: (r) => {
  //       this.notifications.set(r);
  //     },
  //     error: (err) => {
  //       // Aquí ya te llega el `new Error(mensaje)` del servicio
  //       // Puedes mostrarlo como quieras (toast, snackbar, alerta…)
  //       console.warn('Error en notificaciones:', err.message);

  //     },
  //   });
  // }

  getGestorCliente() {
    this.operadorService.getGestorPorOperador().subscribe({
      next: (gestor) => {
        this.datosGestor.set(gestor);
      },
      error: (err) => {
        this.logger.error('Error al obtener el gestor', err);
      },
    });
  }
}
